module.exports = {"id":"34824","name":"Antonio Floro Flores","rating":"72","photo":"./data/images/photos/3/34824.png","club":{"name":"Bari","logo":"./data/images/clubs/Bari.png"},"positions":["BU","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AntonioFloroFlores0.json
// module id = 443
// module chunks = 0